import { MotifButton } from "@ey-xd/motif-react";
import "./ErrorOrderPage.scss";

interface EmptyOrderProps {
  image: string;
  header: string | null;
  handleRefresh: () => void;
}

const ErrorOrderPage: React.FC<EmptyOrderProps> = ({
  image,
  header,
  handleRefresh,
}) => {
  return (
    <div className="home-empty-order-page-default">
      <div>
        <img src={image} alt="Error image" />
      </div>
      <div className="empty-order-page-header">{header}</div>
      <div>
        <MotifButton className="refresh-button" onClick={handleRefresh}>
          Refresh
        </MotifButton>
      </div>
    </div>
  );
};
export default ErrorOrderPage;
